import { createRoot } from 'react-dom/client';
import { Provider as ReduxProvider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import 'simplebar/src/simplebar.css';
import App from './App';
import { store } from './store/store';

// ==============================|| MAIN - REACT DOM RENDER  ||============================== //
const container = document.getElementById('root');

const root = createRoot(container!);
root.render(
  <ReduxProvider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </ReduxProvider>
);
